import styled from 'styled-components';
import {Header, Button, Checkbox} from 'semantic-ui-react';
import FancyPopup from '../components/FancyPage/FancyPopup';

export const TABLET_WIDTH = 1320;
export const SMALL_TABLET_WIDTH = 1000;
export const MOBILE_WIDTH = 600;

export const OnboardingContainer = styled.div`
  margin-bottom: 32px;

  @media (max-width: 520px) {
    margin-bottom: 24px;
  }
`;

export const HomeHeader = styled.div`
  text-align: center;
  margin-bottom: 36px;

  @media (max-width: 768px) {
    margin-top: 24px;
  }

  @media (max-width: 520px) {
    margin-top: 8px;
    margin-bottom: 24px;
  }
`;

const HomeHeaderText = styled.h1`
  max-width: 480px;
  margin: 0 auto;
`;

export const HomeHeaderMainText = styled(HomeHeaderText as any)`
  font-size: 32px;

  @media (max-width: 520px) {
    font-size: 24px;
  }
`;

export const HomeHeaderSubText = styled(HomeHeaderText as any)`
  font-size: 20px;
  margin-top: 16px;
  line-height: 32px;

  @media (max-width: 520px) {
    font-size: 18px;
    line-height: 24px;
  }
`;

export const SectionContainer = styled.div`
  display: flex;
  justify-content: space-between;

  @media (max-width: ${TABLET_WIDTH}px) {
    flex-direction: column;
  }

  @media (max-width: ${SMALL_TABLET_WIDTH}px) {
    display: none;
  }
`;

export const MobileSectionContainer = styled.div`
  @media (min-width: ${SMALL_TABLET_WIDTH + 1}px) {
    display: none;
  }

  @media (max-width: 520px) {
    margin-left: -16px;
    margin-right: -16px;
  }
`;

export const SectionColumn = styled.div`
  display: flex;

  @media (min-width: ${TABLET_WIDTH + 1}px) {
    flex-direction: column;
    justify-content: space-between;

    &:nth-child(1) {
      width: 312px;
    }

    &:nth-child(2) {
      width: 576px;
    }

    &:not(:first-child) {
      margin-left: 32px;
    }
  }

  @media (max-width: ${TABLET_WIDTH}px) {
    width: 100%;
    flex-direction: row;

    &:not(:first-child) {
      margin-top: 32px;
    }
  }
`;

export const Section = styled.div<{grow?: true}>`
  background-color: #fff;
  border-radius: 6px;
  border: 1px solid #dbdbdb;
  padding: 32px;

  ${({grow}) => grow && `flex-grow: 1;`}

  @media (min-width: ${TABLET_WIDTH + 1}px) {
    &:not(:first-child) {
      margin-top: 32px;
    }
  }

  @media (max-width: ${TABLET_WIDTH}px) {
    &:not(:first-child) {
      margin-left: 32px;
    }
  }

  @media (max-width: ${SMALL_TABLET_WIDTH}px) {
    &&&&& {
      margin: 32px 0 0;
    }
  }

  @media (max-width: 520px) {
    &&&&& {
      border-radius: 0;
      border-left: none;
      border-right: none;
      margin-top: 24px;
    }
  }
`;

export const SectionHeader = styled.h3`
  font-size: 20px;
  margin: 0;
`;

export const SectionText = styled.p`
  margin: 16px 0 0;
`;

export const SectionTextSpecial = styled(SectionText as any)`
  color: #aaa;
  font-style: italic;
`;

export const SectionCheckboxContainer = styled.div`
  margin-top: 32px;
  display: flex;
  align-items: center;
`;

export const SectionCheckbox = styled(Checkbox)`
  margin-right: 8px;
`;

export const SectionButton = styled(Button)`
  &&&&& {
    margin: 24px 0 0;
    padding-left: 1em;
    padding-right: 1em;
  }
`;

export const SidebarHeader = styled(Header)`
  color: #aaa;
`;

export const SidebarBlock = styled.div`
  position: relative;
  margin-top: 24px;
`;

export const SidebarBlockHeader = styled.h3`
  margin: 0;
  font-size: 20px;
`;

export const SidebarBlockLink = styled.div`
  display: flex;
  align-items: center;
  margin-top: 12px;
  font-size: 16px;

  a {
    color: #363a3d;

    &:hover {
      color: #007faf;
    }
  }
`;

export const SidebarBlockLinkIcon = styled.img`
  margin-right: 10px;
`;

export const AlertPopup = styled(FancyPopup)`
  left: 100px;
  width: 168px !important;
  height: 62px;
  padding-left: 14px;
  padding-top: 14px;
  padding-bottom: 14px;

  span {
    padding-right: 20px;
  }
`;
